// Module
var code = `<!-- blPrompt — copyable AI prompt block.
     Data shape: { text: "multiline prompt text" }
     Line structure is preserved by the .ai-prompt styles. -->
<div class="ai-prompt">{{text}}</div>
`;
// Exports
module.exports = code;